<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <el-card class="box-card">
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">单位名</div>
          <div class="form_box__group__item__content">{{loadDataSuccess?  partyname : '请稍等'}}</div>
        </div>
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">平均学习课时</div>
          <div class="form_box__group__item__content">{{loadDataSuccess? scoreavg : '请稍等'}}</div>
        </div>
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">共开设课程</div>
          <div class="form_box__group__item__content">{{loadDataSuccess? courses : '请稍等'}}</div>
        </div>

        <div class="form_box__group__item">
          <div class="form_box__group__item__title">数据更新状态</div>
          <div class="form_box__group__item__content">
            <p v-if="!checkStatus  || checkStatus.status == 0">暂未更新</p>
            <p v-else-if="checkStatus.status == 1" style="color: cadetblue;"><i class="el-icon-loading"></i> 更新中 (开始更新时间： {{checkStatus.startTime}} ) </p>
            <p v-else-if="checkStatus.status == 2" style="color: green;">更新完成 (完成更新时间： {{checkStatus.updateTime}} ) <el-button type="primary" @click="updateData" :loading="loading" size="small" style="margin-left: 10px;">点击更新</el-button></p>
            <p v-else-if="checkStatus.status == 3" style="color: red;" >更新失败 <el-button type="primary" @click="updateData" :loading="loading" size="small" style="margin-left: 10px;">点击更新</el-button></p>
          </div>
        </div>



        <div class="form_box__group__item">
              <el-divider content-position="left">人员信息</el-divider>
        </div>

        <div class="form_box__group__item">
           <div class="form_box__group__item__title">
             <el-input v-model="searchword" placeholder="筛选用户信息" @change="onUserChanged"></el-input>
            </div>

            <el-button type="primary" @click="exportUnit" :loading="loading">导出</el-button>
          <!-- <div class="form_box__group__item__content">{{courses}}</div>  -->
        </div>

        <el-table
          :data="showdatas"
          stripe
          style="width: 800px">
          <el-table-column
            prop="name"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="scoreThisYear"
            label="当年所获学时">
          </el-table-column>
          <el-table-column
            prop="scoreOverYears"
            label="历年获得学时">
          </el-table-column>
        </el-table>
    </el-card>




  </div>
</template>


<script>

import { detailUnitApi,exportUnitApi, checkUnitApi, updateUnitApi } from '@/api/module/export/export'


export default {
  name: "export-unit-detail",
  data() {
    return {
      id : "",
      partyname: "",
      scoreavg: "",
      courses : 0,
      datas : [],
      showdatas: [],
      searchword : "",
      downloading : false,
      loading: false,
      checkStatus : null,  // 0 默认 1 更新中 2 更新完成 3 更新失败
      cacheData : {},
      loopInterval : null,
      loadDataSuccess:false,
    }
  },
  methods:{
    
    init(){
      this.loading = true;


      checkUnitApi(this.id)
        .then((r)=>{
          console.log("checkUnitApi",r);

          this.checkStatus = r;

            // 已更新完成
          if(r && r.status == 2){
             this.cacheData = r.data

              this.partyname = r.data.partyName
              this.scoreavg = r.data.scoreAvg
              this.courses = r.data.courses
              this.datas = r.data.userScoreDetailBeanList
              this.showdatas = this.datas
              this.loadDataSuccess = true;
          }

          if(!r || r.status == 0){
             detailUnitApi(this.id)
             this.loopCheck();        
          }

          else if(r.status == 1){
            this.loopCheck();
          }

        })
        .finally(()=>{
          this.loading = false;
        })
    },


    loopCheck(){

      this.loopInterval = setInterval(() => {
        checkUnitApi(this.id)
          .then((r)=>{
            console.log("checkUnitApi in loop",r);
            this.checkStatus = r;

            if(!r || r.status == 0){
              detailUnitApi(this.id)
            }

            else if(r.status == 2){
              clearInterval(this.loopInterval);

              this.partyname = r.data.partyName
              this.scoreavg = r.data.scoreAvg
              this.courses = r.data.courses
              this.datas = r.data.userScoreDetailBeanList
              this.showdatas = this.datas
              this.loadDataSuccess = true;
            }
          })
      }, 1000);
    },

    exportUnit(){
      this.loading = true;
      
      let data = {
        "id": this.id
      }
      exportUnitApi(data)
        .then((res)=>{
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '单位信息.xlsx');
          document.body.appendChild(link);
          link.click()
        })
        .finally(()=>{
          this.loading = false;
        })
      ;
    },


    updateData(){
      // this.loading = true;
      this.loadDataSuccess = false;
      updateUnitApi(this.id)
        .then((r)=>{
          console.log("已清理原数据",r);
          this.loopCheck();
        })
    },



    onUserChanged(val){
      
      if(this.searchword){
        let d = this.datas.filter(item => {
              return item.name.indexOf(this.searchword) > -1;
            })

        this.showdatas = d;
      }
      else {
        this.showdatas = this.datas
      }

    }

  },
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  }
}


</script>



<style scoped>
</style>